import { create } from 'zustand';

interface SecureKeypadState {
  clear?: (fieldId?: string) => void;
  setClear: (fn: (fieldId?: string) => void) => void;
  resetClear: () => void;
  subClear?: (fieldId?: string) => void;
  setSubClear: (fn: (fieldId?: string) => void) => void;
  resetSubClear: () => void;
}

export const useSecureKeypadStore = create<SecureKeypadState>((set) => ({
  clear: undefined,
  setClear: (fn) => set({ clear: fn }),
  resetClear: () => set({ clear: undefined }),
  subClear: undefined,
  setSubClear: (fn) => set({ subClear: fn }),
  resetSubClear: () => set({ subClear: undefined }),
}));
